export const SET_PREVIEW_INFO = 'SET_PREVIEW_INFO'
